import store from "@/store";
import getToken from "@/bin/aws/getToken";
async function fetchToken() {
  if (!store.getters.getAWSUser) {
    console.log("[Auth Token]", "Not Ready");
    return null;
  }
  try {
    return await getToken();
  } catch (err) {
    console.error("[Auth Token]", err);
    return null;
  }
}
export default fetchToken;
